<template>
    <v-container>
      <v-layout row class="layout">
        <v-flex xs12>
        <v-card class="elevation-11" >
          <v-card-text >
        <p class="search" v-if="songlists.length === 0">Loading songlists..........</p>
            <div class="top">
                <h3>{{title}}</h3>
                <v-btn small v-if="isAdmin" class="secondary mr-4 mb-3 add" @click="setNewSonglist">New songlist</v-btn>
            </div>
            <hr>
            <v-layout row> 
              <v-flex xs12>
                <div v-for="sb in songlists" :key="sb.docId">
                    <p v-if="isAdmin"><i class="material-icons icon mr-2" @click="deleteSonglist(sb)">delete_outline</i><a href="#" @click="edit(sb)">{{sb.user}} -- {{sb.name}}</a></p>
                    <p v-else><a href="#" @click="loadSonglist(sb)">{{sb.name}}</a></p>
                </div>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { alphabetize, getLastName } from '../mixins/utilities.js'
export default {
  mounted() {
    window.scrollTo(0, 0);
  },
  computed: {
    songlists() {
      let arrSonglists = this.$store.getters.getSonglists
      return arrSonglists.sort((a, b) => {
        if (getLastName(a.user) < getLastName(b.user)) return -1;
        if (getLastName(a.user) > getLastName(b.user)) return 1;
      })
    },
    isAdmin() {
      return this.$store.state.user.userId === this.$store.state.adminId
    },
    title() {
      let fullname = this.$store.state.user.fname + ' ' + this.$store.state.user.lname
      return this.isAdmin ? 'Songlists' : `${fullname}'s Songlist`
    }
  },
  methods: {
    edit(sb) {
      let arrSongs = []
      let objSong = {}
      if (sb.songs) {
        sb.songs.forEach((el) => {
          objSong = { songId: el.songId, title: el.title }
          arrSongs.push(objSong)
        })
      }

      this.$store.commit('loadSonglist', sb)
      this.$router.push('/editSonglist')
    },
    setNewSonglist() {
      this.$router.push('newSonglist')
    },
    deleteSonglist(sb) {
      let str = `Delete ${sb.name}?`
      if (confirm(str)) {
        this.$store.dispatch('deleteSonglist', sb.docId)
      }
    },
    loadSonglist(sb) {
      this.$store.commit('loadSonglist', { name: sb.name, docId: sb.docId })
      this.$router.push('songlists')
    },
    logOut() {
      this.$store.commit('logOut')
      this.$router.push('/signin')
    }
  },
}
</script>

<style scoped>
.container {
  padding: 0px;
}
.add {
  font-size: 0.75rem;
}
.layout {
  margin-top: 0px;
  margin-left: auto;
  margin-right: auto;
}
.top {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
hr {
  margin-bottom: 20px;
}
p {
  font-size: 0.9rem;
  font-weight: 300;
  margin-bottom: 15px;
}

a {
  color: #3d3d3d;
}

h3 {
  font-size: 1.2rem;
}

h4 {
  font-size: 1.2rem;
}

.search {
  display: flex;
  font-size: 1rem;
}

.icon {
  cursor: pointer;
}
</style>